import ControlViewModel from '@/ViewModels/ControlViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class OptionsLandschaftGroupViewModel extends ControlViewModel {
    
    public label: LabelViewModel;
    public links: KnockoutObservableArray<LinkViewModel>;

    public constructor(params: any) {  
        super(params);

        this.label = this.paramOrDefault(params.label, null);
        this.links = this.observableOrDefault(params.links, []) as KnockoutObservableArray<LinkViewModel>;
    }

}

ComponentManager.setViewModel('OptionsLandschaftGroupViewModel', OptionsLandschaftGroupViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');